module.exports = __webpack_public_path__ + "static/media/kdbake-shop.15f36dd0.jpg";